// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"20":"sandbox","514":"links","594":"about","597":"projects","774":"imprint","859":"experience"}[chunkId] + "." + {"20":"9b250bf6","514":"49eed5fc","594":"44f32abd","597":"93dfef7e","774":"35d64d5d","859":"3b7674a3"}[chunkId] + ".css";
};